export default __webpack_public_path__ + "static/media/no_photo.8bba1105.svg";